export const NAME = "ACTIVITY";
